module.exports = {"title":"Escolha um novo valor para a sua recarga automática ou deixe o escolhido anteriormente:","currency":"R$","button":"Continuar para edição da forma de pagamento"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/EditPaymentRechargePrices/data.json
// module id = 2193
// module chunks = 0